module.exports = __webpack_public_path__ + "99644a3b2db4f087568e3674ced9a29a.png";